import {UseLoader} from "../../../hooks/useLoader";
import React, {useRef, useState} from "react";
import {Toast} from "primereact/toast";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {Dialog} from "primereact/dialog";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {useForm} from "react-hook-form";
import {confirmDialog} from "primereact/confirmdialog";
import {borrarAsociadoContrato} from "../../../api/asociadoContrato.service";

export const ModalEditarAsociadoContrato= ({show, hide, fields}) => {

    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const {register, handleSubmit, formState: {errors}} = useForm();

    const deleteAsociadoCliente = async () => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoad(true);
                    const response= await borrarAsociadoContrato(fields);
                    const data= await response;
                    handleLoad(false);
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            });
        } catch (e) {
            handleLoad(false)
            console.log(e)
        }
    }


    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar Compensacion" visible={show} style={{width: '70vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form autoComplete="false">
                            <h6 className="title-modal">
                                Editar información pensionado
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                <label
                                    className="label-form"
                                    htmlFor="cliente"
                                >
                                    Cliente
                                </label>
                                <select  className="form-input-small"
                                         disabled
                                         id="cliente">
                                    <option value="">{fields.nombre_cliente}</option>
                                    >
                                </select>
                            </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="asociado"
                                    >
                                        Asociado
                                    </label>
                                    <select  className="form-input-small"
                                             disabled
                                             id="asociado">
                                        <option value="">{fields.nombre_asociado}</option>
                                        >
                                    </select>
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={handleSubmit(deleteAsociadoCliente)}
                                    >
                                        Eliminar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <button
                                        className="warning-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>



        </>
    )

}
